<template>
	<div v-if="open">
		<Window :id="'AddNewAccount'" :title="title" ref="Window">
			<div slot="headButton" class="fR cb tra-fast_E ml05x_E">
				<button class="bdSub boxR hover-bg-highLight" @click="Close">
					{{ $t("cmd85", ["取消"]) }}
				</button>
				<button
					@click="save"
					type="button"
					class="functionBtn"
					:class="{ disable: !isSave }"
				>
					{{ $t("cmd84", ["保存"]) }}
				</button>
			</div>
			<div class="w60pct mc mt4x posR">
				<ul class="w44pct_E dpIB_E mt2x_E vaT_E">
					<li style="width: 100%" class="curP_E">
						<MyRadio
							class="dpIB mr2x"
							name="account"
							v-model="result.type"
							label="email"
							>{{
								getLanguageStr("word1577", "用邮箱作为账号")
							}}</MyRadio
						>
						<MyRadio
							class="dpIB mr2x"
							name="account"
							v-model="result.type"
							label="phone"
							>{{
								getLanguageStr("word1576", "用手机号作为账号")
							}}</MyRadio
						>

						<!-- <label class="mr4x"><input type="radio" v-model="result.type" :value="'phone'" name="account">{{getLanguageStr('手机号作为账号','手机号作为账号')}}</label>
                        <label><input type="radio" v-model="result.type" :value="'email'" name="account">{{getLanguageStr('邮箱作为账号','邮箱作为账号')}}</label> -->
					</li>
					<li>
						<div
							class="cSub mb1x"
							:title="getLanguageStr('word67', '姓名')"
						>
							<span class="cWarning">* </span
							>{{ getLanguageStr("word67", "姓名") }}
						</div>
						<InputText
							class="w100pct"
							v-model="result.name"
							name="accountName"
							:verification="'notEmpty'"
						></InputText>
					</li>
					<li class="ml10pct">
						<div
							class="cSub mb1x"
							:title="
								result.type == 'phone'
									? getLanguageStr('word1337', '登录手机号')
									: getLanguageStr('phrase178', '登录邮箱')
							"
						>
							<span class="cWarning">* </span
							>{{
								result.type == "phone"
									? getLanguageStr("word1337", "登录手机号")
									: getLanguageStr("phrase178", "登录邮箱")
							}}
						</div>
						<InputPhone
							@UpdatePhonePrefix="
								(v) => {
									phonePrefix.active = v;
								}
							"
							@UpdatePhoneNumber="
								(v) => {
									result.phoneNumber = v;
								}
							"
							name="phoneNumber"
							v-show="result.type == 'phone'"
							:addClass="'sizeM pl7x'"
						></InputPhone>
						<InputText
							class="w100pct"
							v-model="result.email"
							:verification="'notEmpty,isEmail'"
							name="email"
							v-show="result.type !== 'phone'"
						></InputText>
					</li>
					<li>
						<div
							class="cSub mb1x"
							:title="getLanguageStr('word1633', '登录用户名')"
						>
							{{ getLanguageStr("word1633", "登录用户名") }}
						</div>
						<!--  :verification="'isUsername'" -->
						<InputText
							class="w100pct"
							:only="'username'"
							v-model="result.username"
							name="loginName"
						></InputText>
					</li>
					<li class="ml10pct">
						<div
							class="cSub mb1x"
							:title="getLanguageStr('word672', '初始密码')"
						>
							{{ getLanguageStr("word672", "初始密码") }}
						</div>
						<InputText
							class="w100pct"
							:disabled="true"
							v-model="result.password"
							name="password"
							:placeholder="
								getLanguageStr('word672', '初始密码') +
								'CSIsolar@2026'
							"
						></InputText>
					</li>
					<li>
						<div
							class="cSub mb1x"
							:title="getLanguageStr('word1657', '授权外部角色')"
						>
							<span class="cWarning">* </span
							>{{ getLanguageStr("word1657", "授权外部角色") }}
						</div>
						<Select
							:list="outsideRoles"
							:size="'m'"
							class="w100pct"
							:bindActive="result.role"
							@Click="
								(index) =>
									(result.role = outsideRoles[index].value)
							"
						></Select>
					</li>
				</ul>
			</div>
		</Window>
	</div>
</template>
<script>
import * as lib from "@/util/lib.js";
import { getLanguageStr } from "@/util/language.js";
import { mapGetters } from "vuex";
import Window from "@/components/common/ui/WindowForNew.vue";
import InputText from "@/components/common/ui/InputText.vue";
import Select from "@/components/common/ui/Select.vue";
import MyRadio from "@/components/common/ui/Radio";
import { getOutRoles } from "@/api/manage/roleFunc.js";
import { AddNewUser, AddUserRole } from "@/api/manage/externalRelative.js";
import sha256 from "sha256";

export default {
	name: "relevancePart",
	components: { Window, InputText, Select, MyRadio },
	mounted() {
		lib.fillHeight();
		lib.setScroll($(this.$el).find("[scroll]"));
	},
	watch: {
		result: {
			handler: function (val, oldval) {
				if (val.type == "phone") {
					if (val.phoneNumber && val.name && val.role != 0) {
						this.isSave = true;
						// return true
					} else {
						this.isSave = false;
						// return false
					}
				} else {
					if (val.email && val.name && val.role != 0) {
						this.isSave = true;
						// return true
					} else {
						this.isSave = false;
						// return false
					}
				}
			},
			deep: true,
		},
	},
	computed: {
		...mapGetters({
			userInfos: "user/userInfo",
		}),
		// isSave () {
		//   if (this.result.type == 'phone') {
		//     if (this.result.phoneNumber && this.result.name && this.result.role != 0) {
		//       return true
		//     } else {
		//       return false
		//     }
		//   } else {
		//     if (this.result.email && this.result.name && this.result.role != 0) {
		//       return true
		//     } else {
		//       return false
		//     }
		//   }
		// }
	},
	data() {
		return {
			isSave: false,
			stage,
			open: false,
			title: "",
			outsideRoles: [],
			phonePrefix: {
				// 电话号码前缀
				active: "",
				list: [],
			},
			result: {
				type: "phone",
				name: "",
				phoneNumber: "",
				email: "",
				username: "",
				password: "",
				role: 0,
			},
		};
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		show() {
			this.isSave = false;
			this.open = true;
			this._getRoleList();
			// if (stage.loc.accountFirstUse == 'eMail') {
			//   this.$nextTick(_ => {
			//     this.result.type = 'email'
			//   })
			// }
			if (this.userInfos.organization.areaId == 44) {
				this.$nextTick((_) => {
					this.result.type = "phone";
				});
			} else {
				this.$nextTick((_) => {
					this.result.type = "email";
				});
			}
			setTimeout(() => {
				this.$refs.Window.show();
				this.title = getLanguageStr("cmd100", "创建新用户");
			}, 10);
		},
		reset() {
			this.open = false;
			this.phonePrefix = {
				active: "",
				list: [],
			};
			this.result = {
				type: "phone",
				name: "",
				email: "",
				username: "",
				password: "",
				role: 0,
			};
		},
		_getRoleList() {
			this.outsideRoles = [];
			let request = {
				applyScope: 1, // 1:用户 2:商家
				pageNum: 1,
				pageSize: 50,
				modules: 2, // 1:内部 2：外部
			};
			getOutRoles(request).then(
				(res) => {
					if (res.total > 0) {
						this.outsideRoles = res.roleList.map((el) => ({
							value: el.roleId,
							text: this.getTypeText(el.roleId, "roleType-outer")
								? this.getTypeText(el.roleId, "roleType-outer")
								: el.roleName,
						}));
						this.outsideRoles.unshift({
							text: getLanguageStr("word66", "-请选择-"),
							value: 0,
							token: true,
						});
					} else {
						this.outsideRoles = [];
					}
				},
				(error) => {
					!_.isEmpty(error) && this.$notify(error);
				}
			);
		},
		Close() {
			this.$refs.Window.hide();
			setTimeout(() => {
				this.reset();
			}, 500);
		},
		// 关联人返回
		updatePersonList() {},
		test() {
			this.$refs.test.show();
		},
		save() {
			if (
				this.result.type == "email" &&
				lib.validValue(this.result.email, ["notEmail"]).allClear
			) {
				return false;
			} else {
				let password;
				if (this.stage.loc.loginSystem.sha256) {
					password = this.result.password
						? sha256(this.result.password)
						: sha256("CSIsolar@2026");
				} else {
					password = this.result.password;
				}
				let request = {
					credential: password,
					userInfo: {
						countryCode:
							this.result.type == "phone"
								? this.phonePrefix.active
								: "",
						name: this.result.name,
						email:
							this.result.type == "email"
								? this.result.email
								: "",
						phoneNumber:
							this.result.type == "phone"
								? this.result.phoneNumber
								: "",
						username: this.result.username,
					},
				};
				AddNewUser(request).then(
					(res) => {
						this.buildRel(res);
					},
					(error) => {
						!_.isEmpty(error) && this.$notify(error);
					}
				);
			}
		},
		// 建立关系
		buildRel(userId) {
			let request = {
				targetEntityId: userId,
				roleId: this.result.role,
				targetEntityType: 2,
			};
			AddUserRole(request).then(
				(res) => {
					this.Close();
					this.$emit("updateList", this.result, res);
				},
				(error) => {
					!_.isEmpty(error) && this.$notify(error);
				}
			);
		},
	},
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/view/manage/account/AddNewAccount.vue